import { ComponentStyleConfig } from "@chakra-ui/react";

const DropdownButtonTheme: ComponentStyleConfig = {
  baseStyle: {
    iconContainer: {
      minWidth: 0,
      "& > span": {
        lineHeight: "0",
      },
    },
    button: {
      "& .mb-icon": {
        transition: "transform 0.2s",
        transformOrigin: "center",
      },
      _active: {
        "& .mb-icon": {
          transform: "rotate(180deg)",
        },
      },
    },
    text: {
      marginEnd: "-1px",
    },
  },
  sizes: {
    tight: {
      inlineContainer: {
        paddingRight: "6px",
        paddingLeft: "2px",
        marginInlineStart: "-0.5rem",
      },
      inlineText: {
        fontSize: "12px",
        paddingLeft: "6px",
        paddingRight: "4px",
        py: "4px",
        lineHeight: "16px",
      },
      text: {
        fontSize: "12px",
        paddingLeft: "6px",
        paddingRight: "6px",
        py: "4px",
        lineHeight: "16px",
      },
    },
    md: {
      iconContainer: {
        px: "3px",
        py: "12px", // 8px - 1px border
      },
      text: {
        px: "16px",
        py: "9px", // 10px - 1px border
      },
    },
    sm: {
      iconContainer: {
        px: "3px",
        py: "9px", // 10px - 1px border
      },
      text: {
        px: "14px",
        py: "7px", // 8px - 1px border
      },
    },
    xs: {
      iconContainer: {
        px: "3px",
        py: "8px",
      },
      text: {
        px: "14px",
        py: "5px", // 6px - 1px border
      },
      button: {
        py: 0,
      },
    },
  },
  defaultProps: {
    size: "sm",
  },
};

export default DropdownButtonTheme;
